import { render, staticRenderFns } from "./ProjecaoFinanceira.vue?vue&type=template&id=68867783&"
import script from "./ProjecaoFinanceira.vue?vue&type=script&lang=js&"
export * from "./ProjecaoFinanceira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports